import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c656acfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "customers"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Edificio"),
  /*#__PURE__*/_createElementVNode("th", null, "Planta"),
  /*#__PURE__*/_createElementVNode("th", null, "Número"),
  /*#__PURE__*/_createElementVNode("th", null, "Descripción"),
  /*#__PURE__*/_createElementVNode("th", null, "Responsible"),
  /*#__PURE__*/_createElementVNode("th", null, "Ultimo Pago"),
  /*#__PURE__*/_createElementVNode("th", null, "Deuda")
], -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "der" }, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "noRegist"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.totales.consultorios)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.consultorios, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              onClick: ($event: any) => (this.$router.push(`/consultorios/${item._id}`))
            }, [
              _createElementVNode("td", null, _toDisplayString(item.edificio), 1),
              _createElementVNode("td", null, _toDisplayString(item.planta), 1),
              _createElementVNode("td", null, _toDisplayString(item.numero), 1),
              _createElementVNode("td", null, _toDisplayString(item.descripcion), 1),
              _createElementVNode("td", null, _toDisplayString(item.responsible), 1),
              _createElementVNode("td", null, _toDisplayString($options.newFormatDate(item.ultimoPago)), 1),
              _createElementVNode("td", {
                class: _normalizeClass($options.toColor($options.calcularEdad(item.ultimoPago)))
              }, _toDisplayString($options.calcularEdad(item.ultimoPago)) + " (" + _toDisplayString($options.formatNumber($options.calcularEdad(item.ultimoPago) * item.monto, true)) + ") ", 3)
            ], 8, _hoisted_3))
          }), 128)),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, "Total: " + _toDisplayString($options.formatNumber(this.totales.consultorios)), 1),
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9
          ])
        ]))
      : _createCommentVNode("", true),
    (!this.totales.consultorios)
      ? (_openBlock(), _createElementBlock("h6", _hoisted_10, " No se Encontraron Registros. "))
      : _createCommentVNode("", true)
  ], 64))
}